import React from 'react';
import PropTypes from 'prop-types';
import { RESPONSE_KEYS_MAP } from 'libs/constants';

export default function NoticeMessage({ text, optionalText }) {
  let element = '';
  if (typeof (text) === 'object') {
    const items = Object.keys(text).map(key => (
      <div>
        {RESPONSE_KEYS_MAP[key] || key}: {text[key]}
      </div>
    ));
    element = <div>{items}</div>;
  } else {
    element = <div>{text}</div>;
  }
  return (
    <div>
      {element}
      <div>{optionalText}</div>
    </div>
  );
}

NoticeMessage.propTypes = {
  text: PropTypes.oneOf(['object', 'string']).isRequired,
  optionalText: PropTypes.object.isRequired
};



// WEBPACK FOOTER //
// ./src/components/Notice/NoticeMessage.jsx